export const DDMMyyyy = 'DD.MM.yyyy';

export const DDMMYYYY = 'DD.MM.YYYY';
export const DDMMYYYYWithHours = 'DD.MM.YY | hh:mm';
